import { useStoreI18n } from '@/store'
import { Typo3ReportsLiftAndSlope } from '@/types'
import { BaseLink, Richtext, StatusChip } from '@/ui/components'
import { memo } from 'react'
import IconComponent from '../../Icon'
import MapFrame from '../../MapFrame'

interface Props extends Typo3ReportsLiftAndSlope {
  isLayoutWinter: boolean
}
const AccordionBody = ({ isLayoutWinter, ...data }: Props) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={''}>
      {data?.linkMap && !isLayoutWinter && (
        <BaseLink
          href={data?.linkMap}
          isTransition={false}
          nextLink={false}
          target={'_blank'}
        >
          <MapFrame src={data?.linkMap} />
        </BaseLink>
      )}
      {data?.listLifts?.map((item, i) => (
        <div
          className={'pb-md border-t border-neutral-300'}
          key={i?.toString()}
        >
          <div className="flex justify-between">
            <div>
              <div className="mb-sm flex">
                <StatusChip
                  status={item.liveStatus === 'OPEN' ? 'success' : 'error'}
                />
              </div>

              <div className="textstyle-lg-bold">{item.title}</div>
              <div className="textstyle-sm-regular text-neutral-400">
                {item.typeLabel}
              </div>
            </div>
            <div className="flex size-14 items-center justify-center bg-neutral-300">
              {item?.type && item?.type !== '' && (
                <IconComponent icon={item?.type} className="size-8" />
              )}
            </div>
          </div>

          <div
            className={'pb-sm gap-gutter flex flex-col md:grid md:grid-cols-2'}
          >
            {item?.liveOperatingDates && (
              <div className={''}>
                <>
                  <p className="textstyle-sm-regular text-neutral-400">
                    {D['fe.lift.dates']}
                  </p>
                  <p className={'textstyle-md-regular'}>
                    {item.liveOperatingDates}
                  </p>
                </>
              </div>
            )}
            {item.liveFirstAscent ||
              item.liveFirstDescent ||
              item.liveLastAscent ||
              item.liveLastDescent ||
              (item.liveMoreInfo && (
                <div className={''}>
                  <>
                    <p className="textstyle-sm-regular text-neutral-400">
                      {D['fe.lift.timetable']}
                    </p>
                    <Richtext
                      text={
                        (item.liveFirstAscent
                          ? item.liveFirstAscent + '<br />'
                          : '') +
                        (item.liveFirstDescent
                          ? item.liveFirstDescent + '<br />'
                          : '') +
                        (item.liveLastAscent
                          ? item.liveLastAscent + '<br />'
                          : '') +
                        (item.liveLastDescent
                          ? item.liveLastDescent + '<br />'
                          : '') +
                        (item.liveMoreInfo ? item.liveMoreInfo + '<br />' : '')
                      }
                      className={'textstyle-md-regular'}
                    />
                  </>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default memo(AccordionBody)
